import fb from '@/services/firebase.js'
//import Swal from 'sweetalert2'

export const namespaced = true

export const state = {
  loading: false
}

export const mutations = {
  SET_LOADING(state, value) {
    state.loading = value
  }
}

export const actions = {
  addPaymentDetails({ commit }, payment_details) {
    commit('SET_LOADING', true)
    var id = payment_details.id
    delete payment_details.id
    fb.db.collection('orders').doc(id).update({ payment_details })
  },
  makeCardPayment({ commit, dispatch }, payment_made) {
    commit('SET_LOADING', true)
    fb.db
      .collection('orders')
      .doc(payment_made.tx_ref)
      .update({ payment_made: payment_made })
      .then(() => {
        dispatch('finishOrder', payment_made.tx_ref)
      })
  },
  finishOrder({ commit }, id) {
    commit('SET_LOADING', true)
    fb.db
      .collection('orders')
      .doc(id)
      .update({ 'placing_order.finished_at': Date.now() })
      .then(() => {
        commit('SET_LOADING', false)
        return true
      })
  }
}

export const getters = {}
